export const PRODUCTTYPE_LOADING = "PRODUCTTYPE_LOADING";
export const PRODUCTTYPE_RESET = "PRODUCTTYPE_RESET";
export const GET_STRUCURE = "GET_PRODUCTTYPE";
export const GET_PRODUCTTYPE = "GET_PRODUCTTYPE";
export const GET_PRODUCTTYPE_SUCCESS = "GET_PRODUCTTYPE_SUCCESS";
export const GET_PRODUCTTYPE_FAIL = "GET_PRODUCTTYPE_FAIL";
export const DELETE_PRODUCTTYPE = "DELETE_PRODUCTTYPE";
export const DELETE_PRODUCTTYPE_SUCCESS = "DELETE_PRODUCTTYPE_SUCCESS";
export const DELETE_PRODUCTTYPE_FAIL = "DELETE_PRODUCTTYPE_FAIL";
export const UPDATE_PRODUCTTYPE = "UPDATE_PRODUCTTYPE";
export const UPDATE_PRODUCTTYPE_SUCCESS = "UPDATE_PRODUCTTYPE_SUCCESS";
export const UPDATE_PRODUCTTYPE_FAIL = "UPDATE_PRODUCTTYPE_FAIL";
export const ADD_NEW_PRODUCTTYPE = "ADD_NEW_PRODUCTTYPE";
export const ADD_PRODUCTTYPE_SUCCESS = "ADD_PRODUCTTYPE_SUCCESS";
export const ADD_PRODUCTTYPE_FAIL = "ADD_PRODUCTTYPE_FAIL";
